import { useState } from 'react';
import { useSelector } from 'react-redux';

export default function ShareholderLookup() {
  const [symbol, setSymbol] = useState('SCB');
  const [events, setEvents] = useState([]);
  const csrfToken = useSelector(s => s.csrfToken);
  const base = window.config.base_api_url;

  const fetchEvents = async () => {
    try {
      const res = await fetch(
        `${base}/api/shareholder?companySymbol=${encodeURIComponent(symbol)}`,
        {
          headers: { 'xsrf-token': csrfToken }
        }
      );
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      setEvents(data);
    } catch (err) {
      console.error('Failed to load events:', err);
    }
  };

  return (
    <div>
      <label>
        Company Symbol:
        <input
          value={symbol}
          onChange={e => setSymbol(e.target.value.toUpperCase())}
          style={{ marginLeft: 8 }}
        />
      </label>
      <button onClick={fetchEvents} style={{ marginLeft: 8 }}>
        Load Events
      </button>

      <ul style={{ marginTop: 16 }}>
        {events.map((ev, idx) => (
          <li key={idx} style={{ marginBottom: '1em' }}>
            <strong>{ev.date}</strong>
            {ev.appoint && ev.appoint.length > 0 && (
              <div>
                <em>Appointed:</em> {ev.appoint.join(', ')}
              </div>
            )}
            {ev.resign && ev.resign.length > 0 && (
              <div>
                <em>Resigned:</em> {ev.resign.join(', ')}
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
